(() => {
  'use strict';
  const key = 'finiks-intent-v1';
  const signals = new Set(['catalogue_search', 'guide_question', 'visual_search', 'voice_search', 'product_view', 'variant_selection', 'product_compare', 'cart_opened', 'checkout_intent', 'delivery_request', 'preference_declared']);
  const blank = () => Object.fromEntries([...signals].map(signal => [signal, 0]));
  const normalize = source => Object.fromEntries([...signals].map(signal => [signal, Math.max(0, Math.min(20, Number(source?.[signal]) || 0))]));
  const allowed = () => {
    const state = window.FiniksConsent?.getState?.();
    return Boolean(state?.analyticsAllowed && state?.behaviour);
  };
  const read = () => {
    if (!allowed()) return blank();
    try { return normalize(JSON.parse(sessionStorage.getItem(key) || '{}')); } catch { return blank(); }
  };
  const persist = state => {
    if (!allowed()) return;
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch {}
  };
  const summary = state => {
    const source = normalize(state);
    const discovery = source.catalogue_search + source.visual_search + source.voice_search;
    const consideration = source.product_view + source.variant_selection + source.product_compare;
    const purchase = source.cart_opened + source.checkout_intent;
    const support = source.delivery_request + source.guide_question;
    const estimates = [];
    if (discovery) estimates.push({ label: 'Exploring the catalogue', reason: 'Customer-initiated discovery action' });
    if (consideration) estimates.push({ label: 'Comparing product options', reason: 'Customer-initiated product action' });
    if (purchase) estimates.push({ label: 'Considering a purchase', reason: 'Customer-initiated cart or checkout action' });
    if (support) estimates.push({ label: 'Seeking store guidance', reason: 'Customer-initiated guide action' });
    return { estimates, limitations: ['Session-only aggregate signals', 'No sensitive-attribute inference', 'Not a verified customer fact', 'No automatic marketing or commerce action'] };
  };
  const record = signal => {
    if (!allowed() || !signals.has(signal)) return false;
    const next = read();
    next[signal] = Math.min(20, Number(next[signal] || 0) + 1);
    persist(next);
    document.dispatchEvent(new CustomEvent('finiks:intent-updated', { detail: summary(next) }));
    return true;
  };
  const clear = () => {
    try { sessionStorage.removeItem(key); } catch {}
  };
  const recordInitialSignals = () => {
    if (!allowed()) return;
    record('preference_declared');
    if (/\/products\//.test(window.location.pathname)) record('product_view');
  };
  window.FiniksIntent = { getSummary: () => summary(read()), record };
  document.addEventListener('finiks:consent-changed', event => {
    const state = event.detail || {};
    if (!state.analyticsAllowed || !state.behaviour) { clear(); return; }
    recordInitialSignals();
  });
  recordInitialSignals();
})();
